import { createSlice } from '@reduxjs/toolkit';

export interface ButtonState {
  isPulsing: boolean;
}

const initialState: ButtonState = {
  isPulsing: false
};

export const buttonSlice = createSlice({
  name: 'button',
  initialState,
  reducers: {
    togglePulsing: (state) => {
      state.isPulsing = !state.isPulsing;
    }
  }
});

export const { togglePulsing } = buttonSlice.actions;

export default buttonSlice.reducer;
